import React from 'react';
import Icon from '../AppIcon';
import { useTranslation } from 'react-i18next';

const CheckoutProgress = ({ currentStep = 1, steps = ['Cart', 'Checkout', 'Confirmation'] }) => {
 
 const {t} = useTranslation()
  const getStepStatus = (stepIndex) => {
    if (stepIndex < currentStep) return 'completed';
    if (stepIndex === currentStep) return 'current';
    return 'upcoming';
  };

  const getStepIcon = (stepIndex, status) => {
    if (status === 'completed') return 'Check';
    
    switch (stepIndex) {
      case 0: return 'ShoppingCart';
      case 1: return 'CreditCard';
      case 2: return 'CheckCircle';
      default: return 'Circle';
    }
  };

  return (
    <div className="w-full bg-card border-b border-border py-4">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Desktop Progress */}
        <div className="hidden md:flex items-center justify-between">
          {steps?.map((step, index) => {
            const status = getStepStatus(index);
            const isLast = index === steps.length - 1;
            
            return (
              <div key={index} className="flex items-center flex-1">
                <div className="flex items-center">
                  {/* Step Circle */}
                  <div className={`
                    flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all duration-300
                    ${status === 'completed' 
                      ? 'bg-success border-success text-success-foreground' 
                      : status === 'current' ?'bg-primary border-primary text-primary-foreground' :'bg-background border-border text-muted-foreground'
                    }
                  `}>
                    <Icon 
                      name={getStepIcon(index, status)} 
                      size={20} 
                      color="currentColor"
                    />
                  </div>
                  
                  {/* Step Label */}
                  <div className="ml-3">
                    <p className={`text-sm font-medium ${
                      status === 'current' ?'text-primary' 
                        : status === 'completed' ?'text-success' :'text-muted-foreground'
                    }`}>
                        {t('step')} {index + 1}
                    </p>
                    <p className={`text-xs ${
                      status === 'current' ?'text-foreground' :'text-muted-foreground'
                    }`}>
                       {t(step)}
                    </p>
                  </div>
                </div>
                
                {/* Connector Line */}
                {!isLast && (
                  <div className="flex-1 mx-4">
                    <div className={`h-0.5 transition-colors duration-300 ${
                      index < currentStep - 1 ? 'bg-success' : 'bg-border'
                    }`} />
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Mobile Progress */}
        <div className="md:hidden">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold text-foreground">
           {t(steps[currentStep - 1])}
            </h2>
            <span className="text-sm text-muted-foreground">
               {t('step')} {currentStep} {t('of')} {steps.length}
            </span>
          </div>
          
          {/* Progress Bar */}
          <div className="w-full bg-muted rounded-full h-2">
            <div 
              className="bg-primary h-2 rounded-full transition-all duration-300 ease-out"
              style={{ width: `${(currentStep / steps.length) * 100}%` }}
            />
          </div>
          
          {/* Step Indicators */}
          <div className="flex justify-between mt-3">
            {steps.map((step, index) => {
              const status = getStepStatus(index);
              
              return (
                <div key={index} className="flex flex-col items-center">
                  <div className={`
                    w-6 h-6 rounded-full flex items-center justify-center text-xs transition-all duration-300
                    ${status === 'completed' 
                      ? 'bg-success text-success-foreground' 
                      : status === 'current' ?'bg-primary text-primary-foreground' :'bg-muted text-muted-foreground'
                    }
                  `}>
                    {status === 'completed' ? (
                      <Icon name="Check" size={12} color="currentColor" />
                    ) : (
                      index + 1
                    )}
                  </div>
                  <span className={`text-xs mt-1 ${
                    status === 'current' ?'text-foreground font-medium' :'text-muted-foreground'
                  }`}>
                {t(step)}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutProgress;